import { localize } from '/react4xp/mixins/helpers';
import PrintForm2 from 'mixins/ui/print-form-2';
import React from 'react';

export const columns = (translations: Record<string, any>, token: any, printUrl: string) => [
    {
        title: localize('fno_nz007-submission-date', translations),
        dataIndex: ['nzData', 'submissionDate'],
    },
    {
        title: localize('base', translations),
        dataIndex: ['nzData', 'documentType'],
        render: (documentType) =>
            documentType === 'DECISION'
                ? localize('fno_nz007-decision-tax-authority', translations)
                : localize('fno_nz007-tax-statement-withdrawal', translations),
    },
    {
        title: localize('result', translations),
        dataIndex: ['nzData', 'status'],
        render: (status) =>
            status === 'processed'
                ? localize('fno_nz007-processed', translations)
                : localize('fno_nz007-processed-with-rejection', translations),
    },
    {
        title: localize('fno_nz007-detailed-information', translations),
        render: (_, row) => {
            return (
                <PrintForm2
                    tableModal
                    tokenStr={token}
                    params={{ regNumber: row.nzData.regNumber }}
                    apiUrl={printUrl}
                    translations={translations}
                />
            );
        },
    },
];
